/* =========================================
   PLS Custom JavaScript
   ========================================= */


/* Mobile menu: close drawer after anchor link click */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('header-drawer a[href*="#"]').forEach(function (link) {
    link.addEventListener('click', function () {
      const drawer = link.closest('details');

      if (drawer) {
        drawer.removeAttribute('open');

        const summary = drawer.querySelector('summary');

        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }

        document.body.classList.remove('overflow-hidden-mobile');
        document.body.classList.remove('overflow-hidden-tablet');
      }
    });
  });
});

/* ==================================================
   Desktop Mega Menu - Hover Behaviour
================================================== */

document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(min-width: 990px)').matches) return;

  const megaMenus = document.querySelectorAll(
    '.header__inline-menu details'
  );

  megaMenus.forEach(function (menu) {
    const summary = menu.querySelector('summary');
    const content = menu.querySelector('.mega-menu__content');

    if (!summary || !content) return;

    let closeTimer;

    function openMenu() {
      clearTimeout(closeTimer);

      menu.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      closeTimer = setTimeout(function () {
        menu.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 250);
    }

    summary.addEventListener('mouseenter', openMenu);
    summary.addEventListener('mouseleave', closeMenu);

    content.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openMenu();
    });

    content.addEventListener('mouseleave', closeMenu);

    /* Hire parent click */
    if (summary.textContent.trim() === 'Hire') {
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        window.location.href = '/#hire';
      });
    }
  });
});

(function () {
  function setCommentsPlaceholder() {
    document.querySelectorAll('textarea.araq-form-control').forEach(function (field) {
      const group = field.closest('.araq-form-group');

      if (
        group &&
        group.querySelector('label') &&
        group.querySelector('label').textContent.toLowerCase().includes('anything else we should know')
      ) {
        field.setAttribute(
          'placeholder',
          'e.g. event type, venue, delivery or setup needed'
        );
      }
    });
  }

  setCommentsPlaceholder();

  const observer = new MutationObserver(function () {
    setCommentsPlaceholder();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();